<script setup lang="ts">
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'

import { AppSelect } from '@shared/ui/selects'
import { AppInput } from '@shared/ui/inputs'
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useHelperAction } from '../../api/helpers/action.hook'

defineOptions({
  name: 'HelperDebugNewsletterCard',
})

const { run, isRunning, canRun } = useHelperAction()

const modelTypeOptions: AppSelectOption<string>[] = [
  { value: 'Booking', text: 'Booking' },
  { value: 'Order', text: 'Order' },
  { value: 'Customer', text: 'Customer' },
  { value: 'Assessment', text: 'Assessment' },
  { value: 'Survey', text: 'Survey' },
  { value: 'Subscription', text: 'Subscription' },
]

const refModelType = ref<string>()
const refModelId = ref<string | number>('')
const refNewsletterId = ref<string | number>('')

const isValid = computed<boolean>(() =>
  Boolean(refModelType.value && refModelId.value && refNewsletterId.value))

const send = async (): Promise<void> => {
  const ok = await run('admin.helpers.newsletters.debug', {
    model_type: refModelType.value,
    model_id: Number(refModelId.value),
    newsletter_id: Number(refNewsletterId.value),
  })

  if (ok) {
    refModelType.value = undefined
    refModelId.value = ''
    refNewsletterId.value = ''
  }
}
</script>

<template>
  <CardAdmin
    title="Debug newsletters"
    fullwidth
  >
    <div class="helper-debug-newsletter">
      <AppSelect
        v-model="refModelType"
        :options="modelTypeOptions"
        label="Model type"
        placeholder="Select model type"
      />
      <AppInput
        v-model="refModelId"
        type="number"
        label="Model id"
        placeholder="Enter model id"
      />
      <AppInput
        v-model="refNewsletterId"
        type="number"
        label="Newsletter id"
        placeholder="Enter newsletter id"
      />
      <BtnPrimary
        text="send"
        :disabled="!canRun || isRunning || !isValid"
        @click="send"
      />
    </div>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./HelperDebugNewsletterCard.scss" />
